import { GridView, ViewList } from '@mui/icons-material'
import {
  Container,
  CssBaseline,
  Grid,
  Skeleton,
  Typography,
} from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

import { Lesson } from '../../../components/lesson'
import { THEME } from '../../../global'
import { useLessonViewMode } from '../../../hooks'
import lessons from '../../../services/lessons'
import {
  AppLessonSkeleton,
  EmptyPage,
  ErrorPage,
  Header,
} from '../../../components'

export default function Lessons() {
  const { isListView, toggle } = useLessonViewMode()
  const { id, moduleName, percent } = useParams()

  const {
    data: queryLessons,
    isLoading,
    isError,
  } = useQuery({
    queryFn: () => lessons.getByModuleID(id),
    queryKey: [id],
  })

  if (isError)
    return (
      <>
        <Header />
        <ErrorPage
          text={`Encontramos um erro ao buscar as aulas! Por favor, recarregue a página.`}
        />
      </>
    )

  return (
    <Container component="main" sx={{ fontSize: 35 }}>
      <CssBaseline />
      <Header>
        {!isLoading ? (
          <Typography
            variant="h4"
            color={THEME.colors.disabled}
            sx={{ fontSize: 22, ml: -8 }}
          >
            {percent}%
          </Typography>
        ) : (
          <Skeleton
            variant="text"
            sx={{ fontSize: '1.5rem', width: '40%', mr: 1 }}
          />
        )}

        {!isLoading ? (
          <Typography
            variant="h2"
            sx={{ fontSize: 22, fontWeight: 600, ml: -4 }}
          >
            {moduleName}
          </Typography>
        ) : (
          <Skeleton
            variant="text"
            sx={{ fontSize: '1.5rem', width: '40%', mr: 1 }}
          />
        )}
        <a onClick={() => {}}>
          {isListView ? (
            <GridView onClick={toggle} color="primary" sx={{ fontSize: 35 }} />
          ) : (
            <ViewList onClick={toggle} color="primary" sx={{ fontSize: 38 }} />
          )}
        </a>
      </Header>

      {!isListView ? (
        <Grid
          container
          spacing={{ xs: 1, md: 1 }}
          columns={{ xs: 4, sm: 18, md: 20 }}
        >
          {!isLoading ? (
            queryLessons && queryLessons.length > 0 ? (
              queryLessons?.map((lesson, i) => (
                <Lesson
                  data={lesson}
                  key={lesson.id}
                  index={i}
                  listMode={isListView}
                  lessonState={
                    i === 0 && lesson.state !== 'Done' ? 'Active' : lesson.state
                  }
                />
              ))
            ) : (
              <EmptyPage text={`Desculpa, nenhuma aula foi encontrada!`} />
            )
          ) : (
            <AppLessonSkeleton isListMode={false} />
          )}
        </Grid>
      ) : (
        <>
          {!isLoading ? (
            queryLessons && queryLessons.length > 0 ? (
              queryLessons?.map((lesson, i) => (
                <Lesson
                  data={lesson}
                  index={i}
                  key={lesson.id}
                  listMode={isListView}
                  lessonState={
                    i === 0 && lesson.state !== 'Done' ? 'Active' : lesson.state
                  }
                />
              ))
            ) : (
              <EmptyPage text={`Desculpa, nenhuma aula foi encontrada!`} />
            )
          ) : (
            <AppLessonSkeleton isListMode />
          )}
        </>
      )}
    </Container>
  )
}
